import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';
import { Box, TextButton, WixIcons } from '../../../../components/common';
import { MainSource } from '../../../../constants/Source';
import { useTrackSearchAndFiltersAnalytics } from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics';
import {
  ClickOrigins,
  SearchAndFiltersShowAllTargets,
} from '../../../../utils/hooks/bi/useTrackSearchAndFiltersAnalytics/useTrackSearchAndFiltersAnalytics.types';
import { RouteBuilder } from '../../../../utils/RouteHelpers';
import { IOuter } from '../EmptyState.types';
import { NewSearchButtonNames, useTrackSearch } from '../../../../utils/hooks/bi/useTrachSearch';

export const NewSearchButtons: FC<IOuter> = ({ searchQuery }) => {
  const { trackSearchAndFiltersShowAllClick } = useTrackSearchAndFiltersAnalytics();
  const { trackNewSearchClick } = useTrackSearch();

  const history = useHistory();

  const handleAllResultsClick = useCallback(async () => {
    history.push(RouteBuilder.Search(MainSource.All, searchQuery));

    await trackSearchAndFiltersShowAllClick({
      target: SearchAndFiltersShowAllTargets.AllResults,
      clickOrigin: ClickOrigins.Search,
    });
  }, [history, searchQuery, trackSearchAndFiltersShowAllClick]);

  const handleNewSearchClick = useCallback(() => {
    history.push(RouteBuilder.Source(MainSource.MediaFromWix));

    trackNewSearchClick({
      button_name: NewSearchButtonNames.NewSearch,
    });
  }, [history, trackNewSearchClick]);

  return (
    <Box direction="horizontal" gap={7}>
      <TextButton
        prefixIcon={<WixIcons.SiteSearch />}
        as="a"
        size="small"
        onClick={handleAllResultsClick}
        dataHook="all-results"
      >
        <FormattedMessage id="empty-state.search-all-media-cta" />
      </TextButton>

      <TextButton
        prefixIcon={<WixIcons.Search />}
        as="a"
        size="small"
        onClick={handleNewSearchClick}
        dataHook="new-search"
      >
        <FormattedMessage id="empty-state.search-new-search-cta" />
      </TextButton>
    </Box>
  );
};
